import React, { useState } from "react";
import { QuotationsData } from "../../contexts";

import { QuotationsTable } from "./components";
import { ALL_QUOTATIONS_TYPE } from "../../utils/constants";

function Quotations() {
    const [data, setData] = useState();
    const [quotationType, setQuotationType] = useState(ALL_QUOTATIONS_TYPE);

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <QuotationsData.Provider value={{ data, setData, quotationType, setQuotationType }}>
                <QuotationsTable />
            </QuotationsData.Provider>
        </div >
    );
}

export { Quotations };
